<template>
	<div class="my-xmzx">
		<img src="../../assets/img/xmzx.png" />
	</div>
</template>

<script>
import wx from 'weixin-js-sdk';
import Vue from 'vue';
import { getWxSharService } from '../../service/weChatService';
export default {
	name: 'xmzx',
	data() {
		return {

		};
	},
	mounted() {
		this.share();
	},
	methods: {
		share() {
			console.log(this.$wx);
			const that = this;
			getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
				if (result.status === 1) {
					that.$wx.config({
						debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
						appId: result.datas.appId, // 公众号名称，由商户传入
						timestamp: result.datas.timestamp, // 时间戳，自1970年以来的秒数
						nonceStr: result.datas.nonceStr, // 随机串
						signature: result.datas.signature, // 微信签名
						jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
					});
					that.$wx.ready(function() {
						//分享到朋友圈
						that.$wx.updateTimelineShareData({
							title: '项目在线网', // 分享标题
							link: 'https://www.shoudaole.cn/dist/#/xmzx', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: 'https://www.shoudaole.cn/uploads/xmzxlogo.png', // 分享图标
							success: function() {
								// Toast('分享成功');
							}
						});
						//分享给朋友
						that.$wx.updateAppMessageShareData({
							title: '项目在线网', // 分享标题
							desc: '全心全意为生意人服务', //分享描述
							link: 'https://www.shoudaole.cn/dist/#/xmzx', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: 'https://www.shoudaole.cn/uploads/xmzxlogo.png', // 分享图标
							success: function() {
								// Toast('分享成功');
							}
						});
					});
				} else {
					Toast(result.msg);
				}
			});
		}
	},
};
</script>

<style>
.my-xmzx img{
	background-size: 100%;
	width: 100%;
	min-height: 750px;
	overflow: hidden;
}
</style>
